/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */
import { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Spinner, Form ,Button} from 'react-bootstrap';
import { DoorView } from 'shared/door-view/DoorView';
import { SalesService, LocationService } from 'shared/services';
import moment from 'moment';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import {
    image_thumbnail,
    saleBannerBlue,
    saleBannerBrown,
    saleBannerteel,
    saleBannerPink,
    saleBannernavy,
    saleBannersky,
} from 'shared/images/images';
import Helmet from 'react-helmet';
// import { enablePreviousState } from 'shared/settings/stateMaintain';
import { titleCase } from 'shared/modifiers';
import store from 'features/store';
import { disablePreviousState } from 'shared/settings/stateMaintain';
import { isAuthorized } from 'shared/settings/auth';

import { LOCATION_MILES } from 'shared/settings/config';

import './SalesListForLocation.scss';
import { addDataLayer } from 'shared/utils/utils';

/**
@Author Karthik

@param

@return html code for sales list based on location
**/

class SalesListForLocation extends Component {
    constructor(props) {
        super(props);
        this.headerContentRef = createRef();
        /* Banner background and home images */
        this.banner_images = [
            saleBannerBrown,
            saleBannerPink,
            saleBannerBlue,
            saleBannerteel,
            saleBannernavy,
            saleBannersky,
        ]
        this.state = {
            pageLoading: true,
            innerWidth: window.innerWidth, /* To handle responsive */
            banner_images: this.banner_images[Math.floor(Math.random() * this.banner_images.length)],
            locationDetails: {},
            locationImageList: [],
            nextList: null,
            salesList: [],
            loaderForMore: false,
            noRecordFound: false,
            locationInProgress: {},
            favoriteLocations: [],
            pageTitle: "CTBids",
            pageDescription: "CTBids buyers web app",
            h1Tag: "",
            h2Tag: "",
            footerData: {},
            locationNotFound: false,
            emptyTag: "",
            zipcode: '',
            estateSaleList: [],
            locationList: [],
            locationTitle: '',
            locationLoading: true,
            inactiveSale: true,
        }
        this.locationId = null;
    }
    componentDidMount() {
        this.windowWidthGet();
        window.addEventListener('resize', this.windowWidthGet);
        this.getLocationDetails();
        store.dispatch({ type: 'SET_PREVIOUS_PATH', payload: { component: "SaleListForLocation" } });
        disablePreviousState();
        if (isAuthorized()) {
            this.getFavoriteLocation();
        }
        // window.onpopstate = () => {
        //     enablePreviousState();
        // }
    }


    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps.user) !== JSON.stringify(this.props.user)) {
            if (isAuthorized()) {
                this.getFavoriteLocation();
            } else {
                this.setState({
                    favoriteLocations: []
                });
            }
        }
        window.addEventListener('resize', this.windowWidthGet);
    }

    getLocationDetails = () => {
        const locationCode = this.props.match.params.locationcode;
        const locationStateCode = this.props.match.params.locationstatecode;
        const postData = {
            "sort": [{ "field": "title", "direction": "asc" }],
            "page": { 'size': 10 },
            "filter": [{ "field": "locationstatecode", "value": locationStateCode, "op": "=", "join": "AND" }]
        };
        if (locationCode) {
            postData.filter.push({ "field": "locationcode", "value": locationCode, "op": "=", "join": "AND" });
        } else {
            postData.filter.push({ "field": "locationcode", "value": null, "op": "IS", "join": "AND" });
        }
        LocationService.getLocationList(postData).then(res => {
            const data = res.data.data[0];
            const zipcode = data.zip
            this.setState({
                zipcode: zipcode,
                locationDetails: data
            })
            
            if (data) {
                this.locationId = data.id;
                this.getSaleDetails(zipcode);
                this.getLocationSeoList(data.id);
                this.getLocationSaleList(data.id);
                this.getLocationImageList(data.id);
            } else {
                this.locationNotFound();
            }
        }).catch(error => {
            this.locationNotFound();
        });
        // this.locationId = this.props.match.params.locationcode;
        // this.getRequiredData();
    }

    locationNotFound = () => {
        const locationCode = this.props.match.params.locationcode;
        const locationStateCode = this.props.match.params.locationstatecode;
        const postData = {
            "sort": [{ "field": "title", "direction": "asc" }],
            "page": { 'size': 10 },
            "field":["title","zip"],
            "filter": [
                { "field": "locationstatecode", "value": locationStateCode, "op": "=", "join": "AND" },
                { "field": "miles", "value": LOCATION_MILES, "op": "=", "join": "AND" },
            ]
        }
        if (locationCode) {
            postData.filter.push({ "field": "locationcode", "value": locationCode, "op": "=", "join": "AND" });
        } else {
            postData.filter.push({ "field": "locationcode", "value": null, "op": "IS", "join": "AND" });
        }

        LocationService.getInactiveLocationList(postData).then(res => {
            const locationData = res.data.data;
            const zipcode = locationData[0].zip
            if(locationData){
                const end = moment.utc().add(48, 'hours').format("YYYY-MM-DD HH:mm:ss")
                const twoDaysale = {
                    "page": { "size": 10 },
                    "sort": [{ "field": "endtimeutc", "direction": "asc" }],
                    "field": ["id", "title", "city", "state", "zipcode", "starttime", "endtime", "itemcount", "status", "provenance", "timezoneid", "timezonename", "endtimeutc"],
                    "filter": [
                        { "field": "status", "value": "Started", "op": "=", "join": "AND" },
                        { "field": "zipcode", "value": zipcode, "op": "=", "join": "AND" },
                        { "field": "miles", "value": LOCATION_MILES, "op": "=", "join": "AND" },
                        { "field": "endtimeutc", "value": end, "op": "<=", "join": "AND" },
                        { "field": "isdeleted", "value": 0, "op": "=", "join": "AND" }
                    ]
                }
                SalesService.getSalesList(twoDaysale).then(
                    res => {
                        const saleListData = res.data.data
                        this.setState({
                            locationTitle: locationData[0].title,
                            estateSaleList: saleListData,
                            inactiveSale: false,
                            locationLoading: false,
                            pageLoading: false,
                        })
                    }
                )
            } else {
                this.props.history.push("/");
            }
        })
        .catch(error => {
            this.props.history.push("/");
        });
        

        this.setState({
            locationNotFound: true,
            // pageLoading: false
        });
    }
    
    getInactiveLocationData = () => {
        const locationCode = this.props.match.params.locationcode;
        const locationStateCode = this.props.match.params.locationstatecode;
        const postData = {
            "sort": [{ "field": "title", "direction": "asc" }],
            "page": { 'size': 10 },
            "field":["title","zip"],
            "filter": [
                { "field": "locationstatecode", "value": locationStateCode, "op": "=", "join": "AND" },
                { "field": "miles", "value": LOCATION_MILES, "op": "=", "join": "AND" },
            ]
        }
        if (locationCode) {
            postData.filter.push({ "field": "locationcode", "value": locationCode, "op": "=", "join": "AND" });
        }
        LocationService.getInactiveLocationList(postData).then(res => {
            const locationData = res.data.data;
            const zipcode = locationData[0].zip;
            const end = moment.utc().add(48, 'hours').format("YYYY-MM-DD HH:mm:ss");
            const twoDaysale = {
                "page": { "size": 10 },
                "sort": [{ "field": "endtimeutc", "direction": "asc" }],
                "field": ["id", "title", "city", "state", "zipcode", "starttime", "endtime", "itemcount", "status", "provenance", "timezoneid", "timezonename", "endtimeutc"],
                "filter": [
                    { "field": "status", "value": "Started", "op": "=", "join": "AND" },
                    { "field": "zipcode", "value": zipcode, "op": "=", "join": "AND" },
                    { "field": "miles", "value": LOCATION_MILES, "op": "=", "join": "AND" },
                    { "field": "endtimeutc", "value": end, "op": "<=", "join": "AND" },
                    { "field": "isdeleted", "value": 0, "op": "=", "join": "AND" }
                ]
            }
            SalesService.getSalesList(twoDaysale).then(
                res => {
                    const saleListData = res.data.data
                    this.setState({
                        locationTitle: locationData[0].title,
                        estateSaleList: saleListData,
                        locationLoading: false,
                    })
                }
            )
        }).catch(error => {
            this.props.history.push("/");
        })
    }

    getSaleBannerImage = () => {
        const banner = this.state.locationImageList.filter(x => x.name === 'banner');
        let bgImage = banner.length > 0 ? banner[0].url : this.state.banner_images.bgImage;
        return bgImage; 
    }

    fontColorCheck = () => {
        const bgImage = this.getSaleBannerImage();
        let fontColor = "#ffff";
        if (bgImage === "/static/images/EstateSale/Banner/Banner_steel.jpg" || bgImage === "/static/images/EstateSale/Banner/Banner_neon.jpg" ) {
            fontColor =  '#000000'; 
        }
        return fontColor

    }

    hideHomeIcon = () => {
        const banner = this.state.locationImageList.filter(x => x.name === 'banner');
        return banner.length === 0;
    }

    /* Called when resize the screen */
    windowWidthGet = () => {
        this.setState({
            innerWidth: window.innerWidth
        });
    }

    getLocationSeoList = (locationid) => {
        const seoData = {
            "filter": [
                {
                    "field": "locationid",
                    "value": locationid,
                    "op": "=",
                    "join": "AND"
                }
            ]
        };
        
        LocationService.SEOLocationList(seoData).then(res => {
            const data = res.data.data[0];
            if (data) {
                const details = JSON.parse(data.textcontent);
                this.setState({
                    pageDescription: details.metadescription,
                    pageTitle: details.pagetitle,
                    h1Tag: details.h1tag,
                    h2Tag: details.h2tag,
                    footerData: details.footercopy
                })
            }
        }).catch(error => error);
    }

    getLocationSaleList = (locationid) => {
        const saleList = {
            "sort": [{ "field": "endtimeutc", "direction": "asc" }],
            "field": ["id", "title", "city", "state", "zipcode", "starttime", "endtime", "itemcount", "status", "provenance", "timezoneid", "timezonename", "endtimeutc"],
            "filter": [
                { "field": "locationid", "value": locationid, "op": "=", "join": "AND" }, 
                { "field": "status", "value": "Started", "op": "=", "join": "AND" }
            ],
            "page": { "size": 48 },
        };
        SalesService.getSalesList(saleList).then(
            endingSoon => {
                let temp = [];
                temp = endingSoon.data.data.length > 0 ? endingSoon.data.data : this.state.estateSaleList;
                let salesData = endingSoon.data.data;
                if ( temp.length > 0 ) {
                    const imageListData = { "filter": [{ "field": "saleid", "value": [temp.map(elem => { return elem.id; })], "op": "IN", "join": "AND" }] };
                    SalesService.getSaleImagesList(imageListData).then(
                        saleImageList => {
                            temp.forEach((elem) => {
                                let imageData = saleImageList.data.data.find((image) => {  return image.saleid == elem.id; })
                                if (typeof imageData != "undefined") {
                                    let imageUrlData = imageData.saleimageurl || imageData.locationimageurl;
                                    if ( typeof imageUrlData === 'string' ) {
                                        elem.saleimageurl = imageUrlData.split(',').find(img => { return img.includes('profile#*#'); })?.split("#*#")[1];
                                    }
                                }
                            })
                            this.setState({
                                salesList: salesData,
                                pageLoading: false,
                                locationLoading: false
                            });
                        }        
                    ).catch((error) => {
                        // TODO: Error message handle
                    });
                } else {
                    this.setState({
                        salesList: salesData,
                        pageLoading: false,
                        locationLoading: false
                    });
                }
            }
        ).catch((error) => {
            // TODO: Error message handle
            this.setState({
                noRecordFound: true,
                pageLoading: false,
                locationLoading: false
            });
        });
    }

    getLocationImageList = (locationid) => {
        const locationImageData = { "filter": [{ "field": "locationid", "value": locationid, "op": "=", "join": "AND" }] };
        LocationService.getLocationImagesList(locationImageData).then(
            locationImage => {
                this.setState({
                    locationImageList: locationImage.data.data,
                    pageLoading: false
                });
            }
        ).catch((error) => {
            this.setState({
                noRecordFound: true,
                pageLoading: false
            });
        });
    }

    getFavoriteLocation = () => {
        // TO get the FavoriteLocation list
        const favoritePostData = {
            "sort": [{ "field": "id", "direction": "asc" }],
            "field": ["id", "locationid", "buyerid"]
        };
        if (isAuthorized()) {
        LocationService.getFavoriteLocation(favoritePostData).then(favoriteLocationData => {
            const favoriteLocationDataTemp = favoriteLocationData.data.data;
            this.setState({
                favoriteLocations: favoriteLocationDataTemp
            });
        }).catch(error => {
            // TODO: Error message handle                   
            this.setState({
                noDataFound: true,
                pageLoading: false,
            });

        });
        }
    }
    moreSalesGet = () => {
        this.setState({
            loaderForMore: true
        }, () => {
            const saleList = {
                "sort": [{ "field": "endtimeutc", "direction": "asc" }],
                "field": ["id", "title", "city", "state", "zipcode", "starttime", "endtime", "itemcount", "status", "provenance", "timezoneid", "timezonename", "endtimeutc"],
                "filter": [{ "field": "locationid", "value": this.locationId, "op": "=", "join": "AND" }, { "field": "status", "value": "Started", "op": "=", "join": "AND" }],
                "page": this.state.nextList ? { "size": 6, next: this.state.nextList } : { 'size': 6 }
            };
            const exisitingList = this.state.salesList;
            SalesService.getSalesList(saleList).then(
                endingSoon => {
                    const temp = endingSoon.data.data;
                    const newList = exisitingList.concat(temp);
                    this.setState({
                        salesList: newList,
                        nextList: endingSoon.data.page && endingSoon.data.page.keyset && endingSoon.data.page.keyset.next ? endingSoon.data.page.keyset.next : null,
                        loaderForMore: false
                    });
                }
            ).catch((error) => {
                this.setState({
                    loaderForMore: false
                });
                // TODO: Error message handle
            });
        });
    }
    navigate = (sale) => {
        this.props.history.push(`/estate-sale/${sale.id}`);
    }
    back = () => {
        // enablePreviousState();
        this.props.history.goBack();
        // this.props.history.push(`/locations`);
    }
    openInNewTab = (url) => {
        if (url) {
            const reformat = url.includes('http') ? url : 'http://' + url;
            const newWindow = window.open(reformat, '_blank', 'noopener,noreferrer');
            if (newWindow) newWindow.opener = null;
        }
        let dataLayerData = {
            'event': 'location_visit',
            'title': this.state.locationDetails.title
        }
        addDataLayer(dataLayerData);
    }
    removeSale = (index) => {
        this.setState({
            refreshScreen: true
        }, () => {
            const temp = this.state.salesList;
            temp.splice(index, 1);
            this.setState({
                salesList: temp
            });
            setInterval(() => {
                this.setState({
                    refreshScreen: false
                });
            }, 500)
        });
    }
    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }
    moreSaleLocations = () => {
        this.props.history.push(`/locations`);
    }
    /** ************************************************** */
    /** Favorite Location Button on Each Location - Starts*/
    /** ************************************************** */
    isFavoriteLocation = (location) => {
        return this.state.favoriteLocations.findIndex(x => x.locationid === location.id) > -1;
    }
    signInOpen = (flag) => {
        store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: flag } });
    }



    getSaleDetails = (zipcode) => {
        const end = moment.utc().add(48, 'hours').format("YYYY-MM-DD HH:mm:ss")
        const twoDaysale = {
            "page": { "size": 10 },
            "sort": [{ "field": "endtimeutc", "direction": "asc" }],
            "field": ["id", "title", "city", "state", "zipcode", "starttime", "endtime", "itemcount", "status", "provenance", "timezoneid", "timezonename", "endtimeutc"],
            "filter": [
                { "field": "status", "value": "Started", "op": "=", "join": "AND" },
                { "field": "zipcode", "value": zipcode, "op": "=", "join": "AND" },
                { "field": "miles", "value": LOCATION_MILES, "op": "=", "join": "AND" },
                { "field": "endtimeutc", "value": end, "op": "<=", "join": "AND" },
                { "field": "isdeleted", "value": 0, "op": "=", "join": "AND" }
            ]
        }
        SalesService.getSalesList(twoDaysale).then(
            res => {
                const data = res.data.data
                this.setState({
                    estateSaleList: data,
                    pageLoading: false,
                })
            }
        )
    }
    
    searchPage(){
        this.props.history.push('/advance-search')
    }
    
    /** Favorite Location Click Event */
    favoriteLocation = (event, location) => {
        event.stopPropagation();
        event.preventDefault();
        const value = event.target.checked;
        if (isAuthorized()) {
            this.setState({
                locationInProgress: {
                    ...this.state.locationInProgress,
                    [location.id]: true
                }
            }, () => {
                disablePreviousState();
                if (value) {
                    this.addFavoriteLocation(location);
                } else {
                    this.removeFavoriteLocation(location);
                }
            });
        } else {
            this.signInOpen('Sign-In');
        }
    }
    /** If Favorite Location Button is Checked */
    addFavoriteLocation = (location) => {
        const postData = { "data": { "locationid": location.id } };
        LocationService.addFavoriteLocation(postData).then(res => {
            const favoriteLocations = this.state.favoriteLocations;
            const data = res.data.data[0];
            data['buyerid'] = this.props.user.id;
            favoriteLocations.push(data);
            this.setState({
                favoriteLocations,
                locationInProgress: {
                    ...this.state.locationInProgress,
                    [location.id]: false
                }
            }, () => {
                console.log(this.state);
            });
        }).catch(error => {
            this.setState({
                locationInProgress: {
                    ...this.state.locationInProgress,
                    [location.id]: false
                }
            });
        });
    }
    getProfileImage = (location) => {
        const locationImage = {};
        if (location.imageurl) {
            const image = location.imageurl.split(',');
            image.forEach(x => {
                const temp = x.split('#*#');
                locationImage[temp[0]] = temp[1];
            });
        }
        return locationImage.profile ? locationImage.profile : image_thumbnail;
    }
    
    navigateLocationList = (event, location) => {
        let url = ''
        let classList = [...event?.target?.classList];
        const check = classList.length > 0 && (classList.includes('custom-control-label') || classList.includes('custom-control-input'));
        if (!check) {
            url = location.locationcode ? `/estate-sales/${location.locationstatecode}/${location.locationcode}` : `/estate-sales/${location.locationstatecode}`;
            this.props.history.push(url);
            window.location.reload()
        }   
    }

    /** If Favorite Location Button is UnChecked */
    removeFavoriteLocation = (location) => {
        const favoriteLocations = this.state.favoriteLocations;
        const locationData = favoriteLocations.findIndex(x => x.locationid === location.id);
        const postData = { "data": { "locationIds": [{ "id": location.id }] } };
        LocationService.deleteFavoriteLocation(postData).then(res => {
            favoriteLocations.splice(locationData, 1);
            this.setState({
                favoriteLocations,
                locationInProgress: {
                    ...this.state.locationInProgress,
                    [location.id]: false
                }
            });
        }).catch(error => {
            this.setState({
                locationInProgress: {
                    ...this.state.locationInProgress,
                    [location.id]: false
                }
            });
        });
    }
    handleNext = () => {
        this.slider.slickNext();
      };
    handlePrev = () => {
        this.slider.slickPrev();
      };
    /** ************************************************** */
    /** Favorite Location Button on Each Location - Ends*/
    /** ************************************************** */
    render() {
        const settings = {
            // dots: true,
            infinite: true,
            slidesToShow:  ( this.state.innerWidth > 1000 &&  this.state.estateSaleList.length >= 3 ) ? 3 : ( this.state.innerWidth > 650 && this.state.estateSaleList.length >= 2) ? 2 :  1,
            slidesToScroll: 1,
            autoplay: true,
            speed: 400,
          };
        return (
            <div className="sales-list-main">
                <Helmet>
                    <title>{this.state.pageTitle}</title>
                    <meta name='description' content={this.state.pageDescription} />
                    <meta name="google-site-verification" content="PPiTWW_2xWSo19mPTsAyR2w2L4blIGf5dTyAmvknUrs" />
                    <link rel="canonical" href={`https://ctbids.com${this.props.match.url}`} />
                </Helmet>
                <div className="d-none">
                    {
                        this.state.h1Tag ?
                            <h1>{this.state.h1Tag}</h1>
                            : ''
                    }
                    {
                        this.state.h2Tag ?
                            <h2>{this.state.h2Tag}</h2>
                            : ''
                    }
                </div>
                {
                    this.state.pageLoading || this.state.locationLoading ?
                        <div className="loader d-flex align-items-center justify-content-center">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                        </div> :
                        this.state.noRecordFound ? <div className="no-data-found mt-3 h-100 d-flex flex-column align-items-center justify-content-center">
                            <div className="text-center no-data-search-icon">
                                <i className="fas fa-search fa-3x"></i>
                            </div>
                            <div className="text-center h4 text-bold">
                                No results found
                            </div>
                            <div className="text-center text-muted h5">
                                We couldn't find what you're looking for.
                            </div>
                        </div> :
                           
                                this.state.salesList?.length !== 0 ?
                                <div className="sales-list">
                                    <div className="header-content" ref={this.headerContentRef} style={{ backgroundImage: `linear-gradient(to right, rgba(0 0 0 / 18%), rgb(0 0 183 / 0)), url(${this.getSaleBannerImage()})` }}>
                                        <div className="d-md-flex justify-content-between">
                                            <div className="left d-flex flex-column justify-content-start">
                                                <div className="back-icon-container">
                                                    <div className="back-icon d-flex align-items-center justify-content-start clickable" onClick={this.back}>
                                                        <i className="fas fa-arrow-left"></i>
                                                    </div>
                                                    <div className="content-details">
                                                        <h3  style={{color: `${this.fontColorCheck()}`}}>{this.state.locationDetails.title}</h3>
                                                        {/* {this.state.locationDetails.city}, {this.state.locationDetails.state} {this.state.locationDetails.zip} */}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div  style={{color: `${this.fontColorCheck()}`}}>{this.state.locationDetails.description}</div>
                                                </div>
                                                <div className="sale-provinance">
                                                    {/* Sale Provinance */}
                                                </div>
                                            </div>
                                            <div className="right d-flex justify-content-end align-items-center">
                                                <div className={`icon-image ${this.hideHomeIcon() ? '' : 'd-none'}`}>
                                                    <img src={this.state.banner_images.iconImage} alt="icon" style={{ width: `${this.state.innerWidth > 1366 ? '70%' : '100%'}` }}></img>
                                                </div>
                                                <div className="caring-transition">
                                                    <div className="header">
                                                        Caring Transitions Location
                                                    </div>
                                                    <div className="body-content">
                                                        <div className="user-details d-flex align-items-center clickable" onClick={() => this.openInNewTab(this.state.locationDetails.website)}>
                                                            {/* <img src={sellOne} alt="user-profile"></img> */}
                                                            {
                                                                this.state.locationImageList.filter(x => x.name === 'profile').map((x, index) =>
                                                                    <img src={x.url} className="phone-icon" alt="phone-icons" key={`location_image_${index}`}></img>
                                                                )
                                                            }
                                                            {
                                                                this.state.locationImageList.filter(x => x.name === 'profile').length === 0 ? <img src={image_thumbnail} className="phone-icon" alt="phone-icons" key={`location_image_0`}></img> : null
                                                            }
                                                            <div className="name clickable">
                                                                <div>{this.state.locationDetails.contactname}</div>
                                                                <div >
                                                                    <div className="light-color city-alignment city-new-site-alignment">{titleCase(this.state.locationDetails.city)}</div>
                                                                    <div className="website city-website-alignment city-new-site-alignment">
                                                                        <i className="fas fa-globe"></i> <span>Visit Site</span>
                                                                    </div>
                                                                </div>
                                                                { this.state.locationDetails.auctioneerlicense ? <div className='text-secondary license-resp' style={{ wordBreak: "break-all", overflowWrap: "break-word", maxWidth: "350px" }}><b>License:</b> {this.state.locationDetails.auctioneerlicense}</div> : '' }
                                                            </div>
                                                        </div>
                                                        <div className="email">
                                                            <i className="fas fa-envelope"></i>  <a href={`mailto:${this.state.locationDetails.email}`}>{this.state.locationDetails.email}</a>
                                                        </div>
                                                        <div className="phone">
                                                            <img src={`${process.env.PUBLIC_URL}/static/icons/common-icons/phone.svg`} className="phone-icon" alt="phone-icons"></img><a href={`tel:${this.state.locationDetails.phone}`}>{this.state.locationDetails.phone}</a>
                                                        </div>
                                                        <div className="more-sale" onClick={this.moreSaleLocations}>
                                                            <i className="fas fa-link"></i> <span className="clickable click-more-sale">Please click to check for more sales</span>
                                                        </div>


                                                        {/* Favorite Location Checkbox for each Location Starts */}
                                                        {
                                                            isAuthorized() ?
                                                                <div className="favorite-icon d-flex align-items-center">

                                                                    <Form.Check onChange={(event) => { this.favoriteLocation(event, this.state.locationDetails) }}
                                                                        checked={this.isFavoriteLocation(this.state.locationDetails)}
                                                                        type="checkbox"
                                                                        id={`customControlAutosizing${this.state.locationDetails.id}`}
                                                                        label="Favorite Location"

                                                                        disabled={this.state.locationInProgress[this.state.locationDetails.id]}
                                                                        custom
                                                                    />

                                                                    {
                                                                        this.state.locationInProgress[this.state.locationDetails.id] ?
                                                                            <Spinner animation="border" variant="danger" /> : null
                                                                    }

                                                                </div> : null
                                                        }
                                                        {/* Favorite Location Checkbox for each Location Ends */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="content-body d-flex align-items-center justify-content-center">
                                        <div className="large-screen-width">
                                            {
                                                this.state.refreshScreen ? null :
                                                    <div className="d-flex align-items-center justify-content-center">
                                                        <Row xs={1} sm={1} md={1} lg={this.state.salesList && this.state.salesList.length < 3 ? this.state.salesList.length : this.state.innerWidth < 1225 ? 2 : this.state.innerWidth >= 1707 ? 3 : 3}>
                                                            {
                                                                this.state.salesList.map((items, index) =>
                                                                    <Col key={`items_${index + 1}`}>
                                                                        <DoorView sale={items} config={{ index: index }}{...this.props} navigate={this.navigate} removeSale={() => this.removeSale(index)}></DoorView>
                                                                    </Col>
                                                                )
                                                            }
                                                        </Row>
                                                    </div>
                                            }
                                            {
                                                this.state.salesList.length === 0 ?
                                                    <div className="no-data-found h-80 d-flex flex-column align-items-center justify-content-center">
                                                        {/* <div className="text-center no-data-search-icon">
                                                    <i className="fas fa-search fa-3x"></i>
                                                </div>
                                                <div className="text-center h4 text-bold">
                                                    No results found
                                                </div> */}
                                                        <div className="text-center text-muted h5">
                                                            No current sales from this Seller. Please check back again soon.
                                                        </div>
                                                    </div> : null
                                            }
                                            {
                                                this.state.nextList ?
                                                    <div className="d-flex justify-content-center">
                                                        <div className={`browse-all clickable ${this.state.nextList ? '' : 'custom-disable'} ${this.state.loaderForMore ? 'custom-disable' : ''}`} onClick={this.moreSalesGet}>
                                                            More  {this.state.loaderForMore ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}
                                                        </div>
                                                    </div> : null
                                            }
                                        </div>
                                    </div>
                                </div> 
                                : 
                                <>
                                    { this.state.inactiveSale ? 
                                        <div className="sales-list">
                                        <div className="header-content" ref={this.headerContentRef} style={{ backgroundImage: `url(${this.getSaleBannerImage()})` }}>
                                            <div className="d-md-flex justify-content-between">
                                                <div className="left d-flex flex-column justify-content-start">
                                                    <div className="back-icon-container">
                                                        <div className="back-icon d-flex align-items-center justify-content-start clickable" onClick={this.back}>
                                                            <i className="fas fa-arrow-left"></i>
                                                        </div>
                                                        <div className="content-details">
                                                            <h3 style={{color: `${this.fontColorCheck()}`}}>{this.state.locationDetails.title}</h3>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div style={{color: `${this.fontColorCheck()}`}}>{this.state.locationDetails.description}</div>
                                                    </div>
                                                    <div className="sale-provinance">
                                                    </div>
                                                </div>
                                                <div className="right d-flex justify-content-end align-items-center">
                                                    <div className={`icon-image ${this.hideHomeIcon() ? '' : 'd-none'}`}>
                                                        <img src={this.state.banner_images.iconImage} alt="icon" style={{ width: `${this.state.innerWidth > 1366 ? '70%' : '100%'}` }}></img>
                                                    </div>
                                                    <div className="caring-transition">
                                                        <div className="header">
                                                            Caring Transitions Location
                                                        </div>
                                                        <div className="body-content">
                                                            <div className="user-details d-flex align-items-center clickable" onClick={() => this.openInNewTab(this.state.locationDetails.website)}>
                                                              
                                                                {
                                                                    this.state.locationImageList.filter(x => x.name === 'profile').map((x, index) =>
                                                                        <img src={x.url} className="phone-icon" alt="phone-icons" key={`location_image_${index}`}></img>
                                                                    )
                                                                }
                                                                {
                                                                    this.state.locationImageList.filter(x => x.name === 'profile').length === 0 ? <img src={image_thumbnail} className="phone-icon" alt="phone-icons" key={`location_image_0`}></img> : null
                                                                }
                                                                <div className="name clickable">
                                                                    <div>{this.state.locationDetails.contactname}</div>
                                                                    <div >
                                                                        <div className="light-color city-alignment city-new-site-alignment">{titleCase(this.state.locationDetails.city)}</div>
                                                                        <div className="website city-website-alignment city-new-site-alignment">
                                                                            <i className="fas fa-globe"></i> <span>Visit Site</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="email">
                                                                <i className="fas fa-envelope"></i>  <a href={`mailto:${this.state.locationDetails.email}`}>{this.state.locationDetails.email}</a>
                                                            </div>
                                                            <div className="phone">
                                                                <img src={`${process.env.PUBLIC_URL}/static/icons/common-icons/phone.svg`} className="phone-icon" alt="phone-icons"></img><a href={`tel:${this.state.locationDetails.phone}`}>{this.state.locationDetails.phone}</a>
                                                            </div>
                                                            <div className="more-sale" onClick={this.moreSaleLocations}>
                                                                <i className="fas fa-link"></i> <span className="clickable click-more-sale">Please click to check for more sales</span>
                                                            </div>


                                                            {/* Favorite Location Checkbox for each Location Starts */}
                                                            {
                                                                isAuthorized() ?
                                                                    <div className="favorite-icon d-flex align-items-center">

                                                                        <Form.Check onChange={(event) => { this.favoriteLocation(event, this.state.locationDetails) }}
                                                                            checked={this.isFavoriteLocation(this.state.locationDetails)}
                                                                            type="checkbox"
                                                                            id={`customControlAutosizing${this.state.locationDetails.id}`}
                                                                            label="Favorite Location"

                                                                            disabled={this.state.locationInProgress[this.state.locationDetails.id]}
                                                                            custom
                                                                        />

                                                                        {
                                                                            this.state.locationInProgress[this.state.locationDetails.id] ?
                                                                                <Spinner animation="border" variant="danger" /> : null
                                                                        }

                                                                    </div> : null
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> : ''}
                                <div className="location-list mt-5">

                                    <div className="text-center mt-5 location-msg">
                                        {
                                            this.state.locationTitle ?
                                                <p className='mt-3 location-msg'>Hello! {this.state.locationTitle} is no longer open, however, we have more auctions for you to enjoy!</p> : ''
                                        }
                                    </div>
                                    
                                    {!this.state.locationTitle ?
                                        <div>

                                            <p className="text-center mt-5 location-msg">This location is currently crafting a </p>
                                            <p className="text-center location-msg"> new and unique collection.</p>

                                            <div className="text-center mt-4 location-msg ">
                                                Check back for updates!
                                            </div>
                                        </div> :
                                        ''}
                                    
                                    
                                    {
                                        this.state.estateSaleList?.length !== 0 ?
                                            <div className="text-center " style={{ marginTop: '5%' }}>
                                                <p className="text-center location-msg">Find a sale closest to you.</p>
                                                <p className="text-center location-msg">You're guaranteed to find something you love!</p>
                                            </div> 
                                            : ''
                                    }
                                    
                                    <div style={{ position: 'relative' }}>


                                        <div className="text-center mt-3">
                                            <div className='center-item' style={{ maxWidth: `${this.state.estateSaleList?.length === 1 ? '450px' : this.state.estateSaleList?.length === 2 ? '800px' : ''}` }}>

                                                <Slider  {...settings} ref={(data) => (this.slider = data)} >
                                                    {this.state.estateSaleList.map((saledata, index) => (
                                                        <div className='text-center test'>
                                                            <DoorView sale={saledata} config={{ index: index }}{...this.props} data={true} navigate={this.navigate} ></DoorView>
                                                        </div>
                                                    ))}
                                                </Slider>
                                            </div>

                                            <div className="mt-3 mb-3">
                                                <p className='location-msg'>Looking for something specific?</p>
                                                <Button variant="secondary" className='mt-3 mb-3' onClick={() => this.searchPage()}>
                                                    Search
                                                </Button>
                                            </div>

                                            {/* {!isAuthorized() ?
                                                <div className="text-center mt-5 location-msg">
                                                    <p> Stay in the loop and be the first to know </p>
                                                    about exciting new sales! <br />
                                                    <Button variant="secondary" className="login-button mt-3 mb-5" onClick={() => this.signInOpen('Sign-In')}>Sign Up for Emails</Button>
                                                </div> : ''
                                            } */}
                                            {
                                                this.state.estateSaleList?.length > 3 || (this.state.estateSaleList?.length === 3 && this.state.innerWidth < 850) || (this.state.estateSaleList?.length === 2 & this.state.innerWidth < 650) ?
                                                    <div className="custom-button right-button" style={{ fontSize: '40px' }} onClick={() => this.handleNext()}>
                                                        <i style={{ cursor: 'pointer' }} className="fas fa-chevron-right" />
                                                    </div> : ''
                                            }
                                            {
                                                this.state.estateSaleList?.length > 3 || (this.state.estateSaleList?.length === 3 && this.state.innerWidth < 850) || (this.state.estateSaleList?.length === 2 & this.state.innerWidth < 650) ?
                                                    <div className="custom-button left-button" style={{ fontSize: '40px' }} onClick={() => this.handlePrev()}>
                                                        <i style={{ cursor: 'pointer' }} className="fas fa-chevron-left" />
                                                    </div> : ''
                                            }

                                        </div>
                                    </div>

                                </div>
                                </>

                                    
                            
                }
                {/* <div className="footer-details d-none">
                    {
                        this.state.footerData.h1tag ?
                            <h1>{this.state.footerData.h1tag}</h1>
                            : <h1>{this.state.emptyTag}</h1>
                    }
                    {
                        this.state.footerData.h2tag ?
                            <h2>{this.state.footerData.h2tag}</h2>
                            : <h2>{this.state.emptyTag}</h2>
                    }
                    {
                        this.state.footerData?.h3list instanceof Array && this.state.footerData?.h3list?.map((value, index) =>
                            <h3 key={`h3_${index}`}>{value}</h3>
                        )
                    }
                    {
                        this.state.footerData.paragraphcopy ?
                            <p>{this.state.footerData.paragraphcopy}</p>
                            : <p></p>
                    }
                </div> */}
            </div>
        );
    }
}
export default connect(state => state)(SalesListForLocation);